import axios from '../axios-init';

export const getNurseOfferHistoryList = params=>{
    return axios.post(`/offer/getOfferTakeListHistory`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getProposedOfferList = params=>{
    return axios.post(`/offer/getOfferListByStatus`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getTakeOfferDetail = params=>{
    return axios.post(`/offer/getOfferTakeListByStatusAndOfferNo`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const takeOffer = params=>{
    return axios.post(`/offerTake/takeOffer`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getDoctorOffer = params=>{
    return axios.post(`/offer/queryOfferInfoList`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getNurseOffer = params=>{
    return axios.post(`/offer/getOfferListByDoctorId`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getOfferById = params=>{
    return axios.post(`/offer/queryOfferInfoById`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const editOfferStatus = params=>{
    return axios.post(`/offer/changeOfferStausById`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const addOffer = params=>{
    return axios.post(`/offer/saveOrUpdateOfferInfo`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const expiredOffers = params=>{
    return axios.post(`/offer/queryExpiredOfferInfoListForNurse`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getProposedOffers = params => {
    return axios.post(`/offerProposed/getOfferProposedList`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const requestProposedOffers = params => {
    return axios.post(`/offerProposed/saveOrUpdateProposedInfo`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const editProposedOfferStatus = params => {
    return axios.post(`/offerProposed/changeProposedStausById`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const removeProposedOffer = params => {
    return axios.post(`/offerProposed/removeProposedOffer`,params).then(res=>{
        return res.data;
    }).catch(err=>err)
};

export const getOpenOffers = params => {
    let list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        total: 100,
        user:"护士1",
        quantity: 15,
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-20 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2, 3],
        status: "archived"
    }, {
        id: "2",
        product: 'Product2',
        price: "90",
        total: 150,
        quantity: 20,
        user:"护士1",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "archived"
    }, {
        id: "2",
        product: 'Product3',
        price: "150",
        total: 120,
        quantity: 100,
        user:"护士2",
        createBy: "神医1",
        createDate: "2019-07-15 07:00:00",
        expires: '2019-07-15 00:00:00',
        note: 'test add offer',
        bonus: "10",
        serviceTag: false,
        scope: "private",
        notify: true,
        users: [1, 2],
        status: "canceled"
    }];
    return Promise.resolve(list);
};

export const getOfferDetail = params => {
    let list = [{
        id: "1",
        product: 'Product1',
        price: "100",
        quantity: "20",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0001",
        date: "2019-07-20 12:00:00"
    }, {
        id: "2",
        product: 'Product1',
        price: "105",
        quantity: "15",
        user: "护士1",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }, {
        id: "1",
        product: 'Product1',
        price: "105",
        quantity: "30",
        user: "护士2",
        company: "神医1",
        warehouse: "FL 0002",
        date: "2019-07-20 12:00:00"
    }];
    return Promise.resolve(list);
};

export const getOfferClaimDetails = params => {
    return axios.post(`/offer/getOfferClaimDetails`, params).then(res => {
        return res.data;
    }).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/api/offerService.js